import React from 'react';
import { Text, View } from 'react-native';
import { Interactable, Hr, Icon } from 'LocalGluons';
import { Device, getActualWidth } from 'DeviceUtils';
import Theme from 'Theme';
import { t } from 'Locale';
import styles, { WEB_WIDTH, POPUP_RIGHT_OFFSET, TOP_BAR_TOTAL_HEIGHT } from '../../../Menu.styles';

const fontName = 'materialCommunityIcons';

interface UserPopupProps {
    onLogoutPress: () => void;
    userData: Record<any, any>;
    loginIconPosition: {
        top: number;
        height: number;
        left: number;
        right: number;
        width: number;
    };
}

const UserPopup = ({ onLogoutPress, userData, loginIconPosition }: UserPopupProps): JSX.Element => {
    // needs to be here in case of window resize
    const calculatedRightOffset = (getActualWidth() - WEB_WIDTH) / 2 + POPUP_RIGHT_OFFSET;
    const paddingFromLoginIcon = 20;
    const userPopupStyle = {
        right: calculatedRightOffset,
        top: loginIconPosition.top + loginIconPosition.height + paddingFromLoginIcon
    };

    return (
        <View style={[styles.popup, userPopupStyle, Device.isWeb
            ? {
                marginTop:
                    TOP_BAR_TOTAL_HEIGHT,
                transition:
                    'margin .16s linear'
            } : {}]}>
            <Icon name="" style={styles.popupTriangle} />
            {userData && <Text style={styles.popupText}>{userData.email || userData.login}</Text>}
            <Hr />
            {userData && (
                <Interactable
                    testID="menu_logout_button"
                    style={styles.logOutButton}
                    onPress={onLogoutPress}
                >
                    <Text style={{ color: Theme.placeholderTextColor }}>{t('COMMON.LOGOUT')}</Text>
                </Interactable>
            )}
        </View>
    );
};

export default UserPopup;
